import styled from 'styled-components';

export const ContainerWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 125px;
  z-index: 99999999999999;
`;

export const Container = styled.div`
  width: 90%;
  height: 80%;
  border-radius: 20px;
  box-shadow: 0px 9px 5px -1px rgba(0, 0, 0, 0.4);
  margin: auto;
  background: rgba(255, 255, 255, 1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Info = styled.div`
  width: 15%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const InfoIcon = styled.img`
  width: 100%;
`;
export const InfoDescription = styled.span`
  margin-top: 10px;
`;
export const AddressContainer = styled.div`
  text-align: center;
`;
export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;
export const InfoHint = styled.div`
  font-size: 14px;
  margin-bottom: 10px;
`;
